import { type ButtonHTMLAttributes, type ReactNode } from "react";

type Variant = "primary" | "secondary" | "ghost" | "danger";
type Size = "sm" | "md" | "lg";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  size?: Size;
  children: ReactNode;
  fullWidth?: boolean;
};

const variantClasses: Record<Variant, string> = {
  primary: "bg-penn-900 hover:bg-penn-700 text-white shadow-soft",
  secondary: "border border-gray-200 text-penn-900 hover:bg-gray-50",
  ghost: "text-penn-900 hover:bg-gray-100",
  danger: "bg-red-500 hover:bg-red-600 text-white",
};

const sizeClasses: Record<Size, string> = {
  sm: "px-4 py-2 text-xs rounded-lg",
  md: "px-5 py-3 text-sm rounded-xl",
  lg: "px-6 py-3 text-base rounded-xl",
};

export const PennButton = ({
  variant = "primary",
  size = "md",
  fullWidth = false,
  className = "",
  children,
  ...props
}: ButtonProps) => (
  <button
    {...props}
    className={[
      "font-semibold transition-colors cursor-pointer inline-flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed",
      variantClasses[variant],
      sizeClasses[size],
      fullWidth ? "w-full" : "",
      className,
    ]
      .filter(Boolean)
      .join(" ")}
  >
    {children}
  </button>
);
